module.exports = __webpack_public_path__ + "assets/img/1409.5289f6e0.svg";